import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";

import { useDropzone } from "react-dropzone";

import { InboxOutlined, UploadOutlined, CloudUploadOutlined } from "@ant-design/icons";
import { Button, message, PageHeader, Upload } from "antd";

import { isNotValid, translateSymfonyErrorToFormik } from "../../../core/utils/form";

const propTypes = {
    currentFolder: PropTypes.string.isRequired,
    onChangeUploadMode: PropTypes.func.isRequired,
    onUpload: PropTypes.func.isRequired,
};

const defaultProps = {};

const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
};

const focusedStyle = {
    borderColor: "#2196f3",
};

const acceptStyle = {
    borderColor: "#00e676",
};

const rejectStyle = {
    borderColor: "#ff1744",
};

/*
function Plugin(props) {
  const {
      acceptedFiles, 
      getRootProps, 
      getInputProps,
        isFocused,
    isDragAccept,
    isDragReject
  } = useDropzone({
    getFilesFromEvent: event => myCustomFileGetter(event)
  });

const style = useMemo(() => ({
    ...baseStyle,
    ...(isFocused ? focusedStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isFocused,
    isDragAccept,
    isDragReject
  ]);



  const files = acceptedFiles.map(f => (
    <li key={f.name}>
      {f.name} has <strong>myProps</strong>: {f.myProp === true ? 'YES' : ''}
    </li>
  ));

  return (
    <section className="container">
      <div {...getRootProps({style})}>
        <input {...getInputProps()} directory="" webkitdirectory="" mozdirectory type="file"/>
        <p>Drag 'n' drop some files here, or click to select files</p>
      </div>
      <aside>
        <h4>Files</h4>
        <ul>{files}</ul>
      </aside>
    </section>
  );
}

*/

async function myCustomFileGetter(event) {
    const files = [];
    const fileList = event.dataTransfer ? event.dataTransfer.files : event.target.files;

    for (var i = 0; i < fileList.length; i++) {
        const file = fileList.item(i);

        Object.defineProperty(file, "path", {
            value: file["webkitRelativePath"],
        });

        files.push(file);
    }

    return files;
}

const Basic = (props) => {
    const { acceptedFiles, getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } = useDropzone({
        getFilesFromEvent: (event) => myCustomFileGetter(event),
    });

    const [fileList, setFileList] = useState([]);
    const [uploading, setUploading] = useState(false);
    const handleUpload = () => {
        const formData = new FormData();
        acceptedFiles.forEach((file) => {
            formData.append("paths[]", file.path);
            formData.append("files[]", file);
        });
        setUploading(true);

        formData.append("action", "UPLOAD_FOLDER");
        formData.append("location", props.currentFolder);

        const ret = props.onUpload(formData);

        ret.then((response) => {
            if (isNotValid(response)) {
            } else {
                props.onChangeUploadMode("none");
            }
        })
            .catch((e) => {
                alert("Se ha producido un error desconocido");
            })
            .finally(() => {
                setUploading(false);
            });

        return;
    };

    const style = useMemo(
        () => ({
            ...baseStyle,
            ...(isFocused ? focusedStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {}),
        }),
        [isFocused, isDragAccept, isDragReject]
    );

    const files = acceptedFiles.map((file) => (
        <li key={file.path}>
            {file.path}/{file.name}
        </li>
    ));

    const isBox = !isNaN(+props.currentFolder);
    return (
        <>
            <PageHeader
                title={isBox ? `Upload folder` : `Upload folder to ${props.currentFolder}`}
                extra={[
                    <Button
                        key="cancel-upload"
                        size="small"
                        type="danger"
                        onClick={() => props.onChangeUploadMode("none")}
                    >
                        <CloudUploadOutlined /> Cancel upload
                    </Button>,
                    <Button
                        key="upload-files"
                        size="small"
                        type="primary"
                        onClick={handleUpload}
                        disabled={files.length === 0}
                        loading={uploading}
                    >
                        {uploading ? "Uploading" : "Start Upload"}
                    </Button>,
                ]}
            >
                <section className="container">
                    <div {...getRootProps({ style })}>
                        <input
                            {...getInputProps()}
                            directory=""
                            webkitdirectory="true"
                            multiple
                            mozdirectory
                            type="file"
                        />
                        <p>Drag 'n' drop some folder here, or click to select a folder</p>
                    </div>
                    <aside>
                        <h4>Files</h4>
                        <ul>{files}</ul>
                    </aside>
                </section>
            </PageHeader>
        </>
    );
};

Basic.propTypes = propTypes;
Basic.defaultProps = defaultProps;
export default Basic;
